import { axisBottom, axisLeft, scaleBand, scaleLinear, select, Selection, BaseType } from "d3"
import React, { useRef, useEffect } from "react"
import { usingExplorer } from "../../utility/Utility"

const add3DBar = (
    parent: Selection<BaseType, unknown, HTMLElement, any>,
    xPos: any,
    yPos: number,
    width: number,
    height: number,
    depth: number,
    value: any
) => {
    const g = parent
        .append("g")
        .attr("transform", `translate(${xPos}, ${yPos})`)
    g.append("path")
        .attr("d", `M 0 0 V ${-height} H ${width} V 0 H 0 Z`)
        .style("fill", "#33CCCC")
    g.append("path")
        .attr(
            "d",
            `M 0 ${-height} L ${depth} ${-height - depth} H ${
                depth + width
            } L ${width} ${-height} Z`
        )
        .style("fill", "#72DCDC")
    g.append("path")
        .attr(
            "d",
            `M ${width} 0 L ${width + depth} ${-depth} V ${
                -height - depth
            } L ${width} ${-height} Z`
        )
        .style("fill", "#238B8B")
    g.append("text")
        .attr("font-size", 16)
        .attr("text-anchor", "middle")
        .attr("x", width - 5)
        .attr("y", -height - 34)
        .attr("fill", "black")
        .text(`${value}%`)
}

// function Bars({ data, height, scaleX, scaleY }) {
//     return (
//         <>
//             {data.map(({ value, label }) => (
//                 <Fragment key={`group-${label}`}>
//                     <rect
//                         key={`bar-${label}`}
//                         x={scaleX(label)}
//                         rx="8.6862621"
//                         y={scaleY(value)}
//                         width={scaleX.bandwidth()}
//                         height={height - scaleY(value)}
//                         fill="teal" />
//                     <text
//                         fontSize={17}
//                         textAnchor='middle'
//                         key={`bar-text-${label}`}
//                         x={scaleX(label) + (scaleX.bandwidth() / 2)}
//                         y={scaleY(value) - 25}
//                         fill="black" >
//                         {value}%
//                     </text>
//                 </Fragment>
//             ))}
//         </>
//     );
// }
interface AxisBottomProps {
    scale: any
    transform: string
    transformText: string
}
function AxisBottom({ scale, transform, transformText }: AxisBottomProps) {
    const ref = useRef(null)

    useEffect(() => {
        if (ref.current) {
            select(ref.current).call(axisBottom(scale) as any)
        }
    }, [scale])

    return (
        <>
            <g ref={ref} transform={transform} style={{ fontSize: 14 }} />
            <text textAnchor="middle" transform={transformText}>
                Punteggio di Affidabilità
            </text>
        </>
    )
}
function AxisLeft({ scale }: { scale: any }) {
    const ref = useRef(null)

    useEffect(() => {
        if (ref.current) {
            const scaleMaxNum = scale.domain()[scale.domain().length - 1]
            let scaleNums = [0]
            for (let i = 0; i < Math.round(scaleMaxNum / 10); i++) {
                const element = scaleNums[i]
                scaleNums.push(element + 10)
            }

            select(ref.current).call(axisLeft(scale).tickValues(scaleNums) as any)
        }
    }, [scale])

    return <g ref={ref} style={{ fontSize: 14 }} />
}

function BarChart({ data }: { data: any }) {
    const margin = { top: 60, right: 30, bottom: 80, left: 30 }
    const width = 500 - margin.left - margin.right
    const height = 600 - margin.top - margin.bottom

    const aspect =
        (width + margin.left + margin.right) /
        (height + margin.top + margin.bottom)
    const adjustedHeight = Math.ceil(
        (width + margin.left + margin.right) / aspect
    )

    const scaleX = scaleBand()
        .domain(data.map(({ label }: any) => label))
        .range([0, width * 1.2])
        .padding(0.4)

    const scaleMaxNum = Math.max(...data.map(({ value }: any) => value + 3))

    const scaleY = scaleLinear()
        .domain([0, Math.round(scaleMaxNum)])
        .range([height, 0])

    const addSizeExplorer = usingExplorer() ? 25 : 0

    useEffect(() => {
        data.forEach(({ value, label }: any) =>
            add3DBar(
                select("#bars"),
                scaleX(label),
                height,
                scaleX.bandwidth(),
                height - scaleY(value),
                15,
                value
            )
        )
        return () => {}
    }, [data, height, scaleX, scaleY])

    return (
        <>
            <svg
                preserveAspectRatio="xMinYMin slice"
                viewBox={`0 0 ${
                    (width + margin.left + margin.right) * 2
                } ${adjustedHeight}`}
                id="bar_chart"
            >
                <text
                    fontWeight={"bold"}
                    fontSize={24}
                    transform={`translate(${
                        width + margin.left + margin.right - addSizeExplorer
                    }, 20)`}
                    fill="black"
                    textAnchor="middle"
                >
                    Punteggio per Classi di Affidabilità
                </text>
                <g
                    id="bars"
                    transform={`translate(${
                        (width + margin.left + margin.right) / 2 -
                        addSizeExplorer
                    }, ${margin.top})`}
                >
                    <AxisBottom
                        scale={scaleX}
                        transformText={`translate(${
                            (width + margin.left + margin.right) / 2
                        }, ${height + 60})`}
                        transform={`translate(0, ${height})`}
                    />
                    <AxisLeft scale={scaleY} />

                    {/* <Bars data={data} height={height} scaleX={scaleX} scaleY={scaleY} /> */}
                </g>
            </svg>
        </>
    )
}

export default BarChart
